<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 2.333a1 1 0 01.908.581l3.772 8.173 8.795 1.256a1 1 0 01.492 1.764l-6.825 5.584 2.487 8.7a1 1 0 01-1.486 1.127L16 24.508l-8.142 5.01a1 1 0 01-1.486-1.126l2.486-8.701-6.824-5.584a1 1 0 01.492-1.764l8.794-1.256 3.772-8.173a1 1 0 01.908-.58zm0 3.387l-3.092 6.699-.228.494-.538.077L5.062 14l5.572 4.558.508.417-.18.632-1.96 6.857 6.474-3.983.524-.323.524.323 6.474 3.983-1.96-6.857-.18-.632.51-.417L26.938 14l-7.08-1.011-.538-.077-.228-.494L16 5.719z"/></svg>